<template>
  <v-menu
    v-if="checkPermissionToView"
    :open-on-hover="!touchable"
    left
    offset-y
  >
    <v-btn icon
        id="notification-toggle"
        slot="activator">
      <v-progress-circular
        v-if="isLoading"
        :width="2"
        indeterminate
        class="notification__loader__spinner"
      ></v-progress-circular>
      <div
        ref="notificationBtn"
        tabindex="0"
        class="notification"
      >
        <i
          :class="`bexsicon-notification prepend-badge ${newNotifications === 0 ? 'no-badge' : ''}`"
          :data-badge="newNotifications"
        />
      </div>
    </v-btn>
      <v-list dense class="notification__dropdown">
        <v-list-tile
            @click="clicked(item)"
            class="notification__dropdown__item"
            v-for="(item, i) in items" :key="i"
        >
        <v-list-tile-content>
          <v-list-tile-title>
            <v-layout align-center justify-space-between row fill-height>
            <span class="notification__dropdown__item__icon">
                <i :class="`bexsicon-${item.icon}`" :style="{ color: item.color }" />
            </span>
            <span
              class="notification__dropdown__item__title"
              :class="{notification__dropdown__item__title__visualized: item.visualized}"
            >
                {{ item.title }}
            </span>
            <span class="notification__dropdown__item__time">
                {{ formatNotificationDateTime(item.time) }}
            </span>
            </v-layout>
          </v-list-tile-title>
        </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
          v-if="items.length === 0"
          class="notification__dropdown__item"
        >
          <template v-if="!isLoading">
              <span class="notification__dropdown__item__icon">
                  <i
                    :class="`bexsicon-msg-sent`"
                    :style="{ color: 'green' }"
                  />
              </span>
              <span class="notification__dropdown__item__title">
                  Não há novas notificações.
              </span>
          </template>
          <template v-else>
              <span class="notification__dropdown__item__icon">
                  <v-progress-circular
                    indeterminate
                    :size="24"
                    :width="2"
                    class="notification__loader__inner-spinner"
                  ></v-progress-circular>
              </span>
              <span class="notification__dropdown__item__title">
                  Carregando notificações
              </span>
          </template>
        </v-list-tile>
      </v-list>
  </v-menu>
</template>

<script>
import {
  NOTIFICATIONS
} from '../utils/constants'
import { hasPermission } from '../utils'
import { PROFILES } from '../utils/constants'
export default {
  name: 'notification',
  props: {
    items: {
      type: Array,
      required: false,
    }
  },
  computed: {
    isLoading() {
      return this.$store.getters[NOTIFICATIONS.LOADING]
    },
    newNotifications() {
      if (this.isLoading) {
        return 0
      }
      return this.items.reduce(function (total, notification) {
        return !notification.visualized ? total + 1 : total
      }, 0)
    },
    checkPermissionToView() {
        return this.permissions.length > 0 ? hasPermission(this.permissions) : true
    }
  },
  data() {
    return {
      notificationBtn: null,
      permissions: [PROFILES.ADMIN_PROFILE, PROFILES.ADMIN_BEXS_PROFILE, PROFILES.ADMIN_HR_PROFILE, PROFILES.HR_PROFILE]
    }
  },
  mounted() {
    this.notificationBtn = this.$refs.notificationBtn
  },
  methods: {
    clicked(item) {
      if (item.link && typeof item.link === 'object') this.$router.push(item.link)
      else if (typeof item.link === 'string') {
        window.open(item.link, '_blank')
      }
      this.$emit('clicked', item)
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/breakpoint';

.notification {
  display: inline-block;
  outline: none;
  font-size: .8em;

  &__loader {
    background: rgba(0, 0, 0, 0.25);
    width: 100%;
    height: 100%;
    z-index: -100;
    position: absolute;

    &__spinner {
      color: var(--brand-color);
      width: 70% !important;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      position: absolute;
      z-index: -99;

    }

    &__inner-spinner {
      color: var(--brand-color);
      z-index: -99;
    }

  }

  i {
    font-size: var(--icon-size);
  }

  @include breakpoint(phone) {
    font-size: 1em;
  }

  .prepend-badge {
    position: relative;
    font-size: 18px;

    &[data-badge]:after {
      content: attr(data-badge);
      position: absolute;
      top: -5px;
      right: -5px;
      font-size: 0.6em;
      background: red;
      color: #fff;
      width: 15px;
      font-weight: 600;
      font-family: 'Open Sans', sans-serif;
      height: 15px;
      text-align: center;
      line-height: 15px;
      border-radius: 50%;
    }
  }

  .no-badge {
    &::after {
      display: none !important;
    }
  }

  &__dropdown {
    box-shadow: var(--box-shadow);
    border-radius: 2.5px;
    background-color: #fff;
    list-style: none;
    outline: none;
    overflow: auto;
    max-height: calc(41.3px * 15);

    @media all and (max-height: 650px) {
        max-height: 85vh;
    }

    &__item {

      &:not(:last-child) {
        border-bottom: 1px solid var(--border-light-color);
      }

      padding: 0;
      width: 330px;
      font-size: 70%;

      @include breakpoint(not-mobile) {
        width: 410px;
        font-size: 1.2em;
      }

      &__icon {
        flex: .1;
        font-size: 1.5em;
        text-align: center;
      }

      &__title {
        flex: .9;
        text-align: left;
        font-weight: var(--font-weight);
        color: var(--light-dark-color);
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        margin: auto;
        &__visualized {
          font-weight: 300;
        }
      }

      &__time {
        flex: .1;
        text-align: center;
        padding: .3em 0;
        font-size: .9em;
        color: var(--label-color);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Notification.vue